import columns from '../../../../../react-table/helpers/columns';

export const predesSendingResdesReceivingConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['predes.senderOperatorCode'] !== rowInfo.row['resdes.receiverOperatorCode']) {
      className = 'bg-orange-amber';
    }
  }
  return {
    className,
  };
};

export const predesReceivingResdesSendingConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row['predes.receiverOperatorCode'] !== rowInfo.row['resdes.senderOperatorCode']) {
      className = 'bg-blue-spindle';
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn, NumberColumn,
  } = columns(data);

  return [
    {
      Header: 'PREDES',
      columns: [
        new TextColumn('Origin IMPC', 'predes.originIMPC'),
        new TextColumn('Sender', 'predes.senderOperatorCode').withGetProps(predesSendingResdesReceivingConditionalProps),
        new TextColumn('Receiver', 'predes.receiverOperatorCode').withGetProps(predesReceivingResdesSendingConditionalProps),
      ],
    },
    {
      Header: 'RESDES',
      columns: [
        new TextColumn('Sender', 'resdes.senderOperatorCode').withGetProps(predesReceivingResdesSendingConditionalProps),
        new TextColumn('Receiver', 'resdes.receiverOperatorCode').withGetProps(predesSendingResdesReceivingConditionalProps),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new TextColumn('Despatch type', 'receptacles.despatchType'),
        new NumberColumn('Count', 'receptacles.count'),
        new TextColumn('Receptacle ID example', 'receptacles.receptacleIdExample').withWidth(300),
      ],
    },
  ];
};
